const translations = {
  common: {
    logo: "KOON-SERVICE",
    viewService: "ดูบริการ",
    explore: "สำรวจบริการ",
    contactHelp: "ติดต่อให้เราช่วยแก้ปัญหา",
    contactButton: "ติดต่อเรา",
    footer: "© 2026 Koon-Service. All rights reserved. พัฒนาโดย นักศึกษาสาขาเทคโนโลยีดิจิทัลและสารสนเทศ ระดับปริญญาตรี",
    phone: "โทร : 062-428-3696",
    line: "Line : @koon_s",
    email: "E-mail : kvs_service@koonservice.com",
    hours: "ทุกวัน : 8:00 - 17:00 น.",
  },
  nav: {
    home: "หน้าแรก",
    services: "บริการ",
    about: "เกี่ยวกับ",
    contact: "ติดต่อ",
  },
  language: {
    th: "ไทย 🇹🇭",
    en: "EN 🇺🇸",
    lo: "ລາວ 🇱🇦",
    mm: "MM 🇲🇲",
  },
  hero: {
    subtitle: "โซลูชัน IT มืออาชีพสำหรับธุรกิจของคุณ",
    cta: "สำรวจบริษัท",
  },
  home: {
    servicesTitle: "บริการของเรา",
    whyTitle: "ทำไมต้องเลือกเรา",
    why: [
      {
        title: "รวดเร็ว",
        desc: "เราพร้อมให้บริการอย่างรวดเร็ว ลดเวลาการหยุดชะงักของระบบ และช่วยให้ธุรกิจของคุณดำเนินงานได้อย่างต่อเนื่อง",
      },
      {
        title: "มืออาชีพ",
        desc: "ทีมงานของเรามีประสบการณ์ด้าน IT มากกว่า 5 ปี พร้อมแก้ไขปัญหาได้อย่างตรงจุดและมีประสิทธิภาพสูงสุด",
      },
      {
        title: "คุณภาพสูง",
        desc: "เราใช้มาตรฐานระดับสากลในการให้บริการ เพื่อให้ระบบของคุณมีความเสถียร ปลอดภัย และพร้อมใช้งานตลอดเวลา",
      },
    ],
    contactTitle: "ช่องทางติดต่อ",
    address1: "บริษัท คูนเซอร์วิส จำกัด\n329 ม.10 ถนนสายหลัก แขวงบางเสาธง\nอำเภอบางเสาธง จังหวัดสมุทรปราการ 10570",
    address2: "บริษัท คูนเซอร์วิส จำกัด\n18 ซอย ลาซาล 65 แขวงบางนาใต้\nเขตบางนา กรุงเทพมหานคร 10260",
  },
  services: {
    itService: "IT Service",
    cctv: "CCTV",
    equipment: "IT Equipment",
    network: "NETWORK",
  },
  itService: {
    title: "IT Service",
    introTitle: "บริการช่าง IT สำหรับองค์กร",
    introText: "เราให้บริการทีมช่าง IT Outsource ที่มีความเชี่ยวชาญ รองรับการติดตั้ง แก้ไข และดูแลระบบ IT เพื่อให้องค์กรของคุณทำงานได้อย่างต่อเนื่องและมีประสิทธิภาพ",
    detailTitle: "ขอบเขตการให้บริการ",
    pointsLeft: [
      "ติดตั้งระบบคอมพิวเตอร์ และ Network",
      "ตรวจสอบและแก้ไขปัญหา Hardware / Software",
      "ดูแล Server และระบบภายในองค์กร",
      "Support ผู้ใช้งาน (Helpdesk)",
      "Setup ระบบ WiFi / LAN",
    ],
    pointsRight: [
      "บำรุงรักษาระบบ IT",
      "ดูแล Security / Firewall",
      "สำรองข้อมูล (Backup)",
      "Monitor ระบบ 24/7",
      "ให้คำปรึกษาด้าน IT",
    ],
    problemsTitle: "หากคุณกำลังเจอปัญหาเหล่านี้",
    ctaContact: "ติดต่อให้เราช่วยแก้ปัญหา",
  cards: [
  {
    title: "โปรเจคเยอะ",
    desc: "ต้องการช่างเพื่อรองรับโปรเจค",
  },
  {
    title: "หาช่างไม่ได้",
    desc: "ไม่สามารถหาช่างที่มีทักษะได้",
  },
  {
    title: "บริหารทีมไม่ได้",
    desc: "บริหารจัดการทีมงานจำนวนมากไม่ได้",
  },
  {
    title: "งบประมาณจำกัด",
    desc: "ไม่สามารถจ้างพนักงานประจำเพิ่มได้",
  },
],
},
  cctv: {
    title: "CCTV & SECURITY",
    introTitle: "บริการติดตั้งและดูแลระบบ CCTV & Security",
    introText: "เราให้บริการออกแบบ ติดตั้ง และดูแลระบบกล้องวงจรปิด (CCTV) พร้อมระบบรักษาความปลอดภัยแบบครบวงจร สำหรับองค์กร อาคารสำนักงาน โรงงาน และธุรกิจทุกประเภท โดยทีมงานมืออาชีพ เพื่อเพิ่มความปลอดภัยและความมั่นใจให้กับธุรกิจของคุณ",
    detailTitle: "ขอบเขตการให้บริการ",
    pointsLeft: [
      "ออกแบบและติดตั้งระบบ CCTV ตามพื้นที่ใช้งาน",
      "ติดตั้งกล้อง IP Camera และ Analog Camera",
      "วางระบบสายสัญญาณและอุปกรณ์เครือข่าย",
      "ติดตั้งเครื่องบันทึกภาพ (NVR / DVR)",
      "ตั้งค่าดูภาพผ่านมือถือและอินเทอร์เน็ต",
    ],
    pointsRight: [
      "ดูแลและบำรุงรักษาระบบ CCTV",
      "ตรวจสอบและแก้ไขปัญหาระบบกล้อง",
      "ปรับปรุงและอัปเกรดระบบเดิม",
      "ให้คำปรึกษาด้านระบบรักษาความปลอดภัย",
      "บริการดูแลระบบแบบรายเดือน (Maintenance)",
    ],
    problemsTitle: "ปัญหาที่มักพบเกี่ยวกับระบบ CCTV",
    cards: [
      { title: "มองเห็นไม่ชัด", desc: "ภาพไม่คมชัด หรือมองไม่เห็นในเวลากลางคืน" },
      { title: "ติดตั้งไม่ถูกต้อง", desc: "มุมกล้องไม่ครอบคลุมพื้นที่สำคัญ" },
      { title: "ระบบไม่เสถียร", desc: "กล้องหลุดบ่อย หรือไม่สามารถดูย้อนหลังได้" },
      { title: "ไม่มีผู้ดูแลระบบ", desc: "ไม่มีทีมดูแลระบบเมื่อเกิดปัญหา" },
    ],
    ctaContact: "ติดต่อให้เราช่วยแก้ปัญหา",
  },
  equipment: {
    title: "IT Equipment",
    introTitle: "จำหน่ายและติดตั้งอุปกรณ์ IT ครบวงจร",
    introText: "เราจำหน่ายและให้บริการติดตั้งอุปกรณ์ IT สำหรับองค์กร เช่น คอมพิวเตอร์ เซิร์ฟเวอร์ อุปกรณ์เครือข่าย และระบบสำนักงานครบวงจร พร้อมให้คำแนะนำในการเลือกใช้อุปกรณ์ที่เหมาะสมกับธุรกิจของคุณ เพื่อเพิ่มประสิทธิภาพในการทำงานและลดต้นทุนในระยะยาว",
    detailTitle: "ขอบเขตการให้บริการ",
    pointsLeft: [
      "จำหน่ายคอมพิวเตอร์ PC / Notebook",
      "จำหน่ายอุปกรณ์ Network (Router, Switch, Access Point)",
      "จำหน่าย Server และอุปกรณ์จัดเก็บข้อมูล (NAS)",
      "อุปกรณ์สำนักงาน เช่น Printer / Scanner",
      "อุปกรณ์เสริม เช่น UPS / Rack / สายสัญญาณ",
    ],
    pointsRight: [
      "บริการติดตั้งและตั้งค่าอุปกรณ์",
      "วางระบบ Network สำหรับองค์กร",
      "ติดตั้งระบบ Server และระบบสำรองข้อมูล",
      "ให้คำปรึกษาเลือกอุปกรณ์ให้เหมาะกับงาน",
      "บริการหลังการขายและดูแลระบบ",
    ],
    cards: [
      { title: "อุปกรณ์ล้าสมัย", desc: "คอมพิวเตอร์หรือระบบทำงานช้า ไม่รองรับงานใหม่" },
      { title: "เลือกอุปกรณ์ไม่เหมาะสม", desc: "ซื้อมาแล้วใช้งานไม่ตรงกับความต้องการ" },
      { title: "ระบบไม่เสถียร", desc: "อุปกรณ์มีปัญหาบ่อย ส่งผลต่อการทำงาน" },
      { title: "ไม่มีผู้ดูแล", desc: "ไม่มีทีม IT คอยดูแลและแก้ไขปัญหา" },
    ],
    ctaTitle: "ต้องการอุปกรณ์ IT สำหรับองค์กร ?",
    ctaText: "ปรึกษาผู้เชี่ยวชาญเพื่อออกแบบระบบที่เหมาะกับธุรกิจของคุณ",
    ctaContact: "ติดต่อเราเพื่อสั่งซื้ออุปกรณ์",
    featuredProducts: "สินค้าที่แนะนำ",
  },
  network: {
    title: "NETWORK & SECURITY",
    introTitle: "บริการวางระบบ Network และความปลอดภัย",
    introText: "เราให้บริการออกแบบ ติดตั้ง และดูแลระบบเครือข่าย (Network) พร้อมระบบรักษาความปลอดภัย (Security) สำหรับองค์กรทุกขนาด เพื่อให้การสื่อสารข้อมูลภายในมีความเสถียร ปลอดภัย และรองรับการเติบโตของธุรกิจในระยะยาว",
    detailTitle: "ขอบเขตการให้บริการ",
    pointsLeft: [
      "วางระบบเครือข่าย LAN / WiFi ภายในองค์กร",
      "ติดตั้ง Router, Switch, Access Point",
      "ออกแบบโครงสร้าง Network ตามขนาดองค์กร",
      "ติดตั้งระบบ VLAN และจัดการ Traffic",
      "เชื่อมต่อระบบอินเทอร์เน็ตและ Cloud",
    ],
    pointsRight: [
      "ติดตั้ง Firewall ป้องกันการโจมตี",
      "ป้องกันไวรัสและ Malware",
      "ตั้งค่าระบบ VPN สำหรับการทำงานระยะไกล",
      "ป้องกันข้อมูลรั่วไหล (Data Protection)",
      "Monitoring ระบบ Network แบบเรียลไทม์",
    ],
    problemsTitle: "ปัญหาที่พบบ่อยในระบบ Network",
    cards: [
      { title: "อินเทอร์เน็ตช้า", desc: "เครือข่ายไม่เสถียร ทำงานล่าช้า" },
      { title: "ระบบล่มบ่อย", desc: "Network ไม่เสถียร ส่งผลต่อธุรกิจ" },
      { title: "โดนโจมตี", desc: "ไม่มีระบบป้องกัน เช่น Firewall หรือ Security" },
      { title: "ข้อมูลไม่ปลอดภัย", desc: "เสี่ยงต่อการถูกแฮกหรือข้อมูลรั่วไหล" },
    ],
    ctaTitle: "ต้องการวางระบบ Network ให้ปลอดภัย ?",
    ctaText: "ปรึกษาผู้เชี่ยวชาญเพื่อออกแบบระบบที่เหมาะกับธุรกิจของคุณ",
    ctaContactText: "ติดต่อให้เราช่วยแก้ปัญหา",
  },
};
export default translations;